import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { DefaultSchemaBase } from '@/modules/message/components/editor/schema.ts'

const Schema = DefaultSchemaBase.extend({
  sequenceId: z.number().optional(),
  statistic: z
    .object({
      totalPPVBought: z.number(),
      totalReads: z.number(),
      totalSent: z.number(),
      totalResponses: z.number(),
    })
    .optional(),
})

export const resolver = zodResolver(Schema)
